import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";
import { BasicTooltip } from "./Tooltip";
import { cn } from "@/lib/utils";

export interface ContextMenuItems<TData> {
  id: string;
  label: string;
  icon?: React.ReactNode;
  onClick?: (data: TData) => void;
  getContent?: (data: TData) => React.ReactNode;
  getDisabled?: (data: TData) => boolean;
  tooltipContent?: string;
  className?: string;
}

export const ContextMenu = <TData,>({
  contextMenuItems,
  data,
  children,
  isDisabled,
}: {
  contextMenuItems?: ContextMenuItems<TData>[];
  data: TData;
  children: React.ReactNode;
  isDisabled?: boolean;
}) => {
  return (
    <ContextMenuPrimitive.Root>
      <ContextMenuPrimitive.Trigger disabled={isDisabled}>
        {children}
      </ContextMenuPrimitive.Trigger>
      <ContextMenuPrimitive.Content className="w-56 rounded-md border bg-white p-2 shadow-md">
        {contextMenuItems?.map((item) => (
          <ContextMenuPrimitive.Item
            disabled={item.getDisabled?.(data)}
            className={cn(
              item.className,
              item.getContent
                ? "cursor-default"
                : "cursor-pointer rounded-md hover:bg-gray-50",
              item.getDisabled?.(data) &&
                "cursor-not-allowed opacity-75 hover:!bg-transparent",
              "px-2 py-1",
            )}
            key={item.id}
            onClick={() => {
              item.onClick?.(data);
            }}
          >
            {item.getContent ? (
              item.getContent(data)
            ) : (
              <BasicTooltip
                shouldShow={Boolean(
                  item.getDisabled?.(data) && item.tooltipContent,
                )}
                content={item.tooltipContent}
              >
                <span className="flex items-center">
                  {item.icon && <span className="mr-2">{item.icon}</span>}
                  <span>{item.label}</span>
                </span>
              </BasicTooltip>
            )}
          </ContextMenuPrimitive.Item>
        ))}
      </ContextMenuPrimitive.Content>
    </ContextMenuPrimitive.Root>
  );
};
